/**
 * Lightweight, brand-consistent wrapper for all Smibha Aura policy/info pages.
 * Centralises typography, max-width, and the back-to-shop affordance so the
 * pages stay visually aligned even as we iterate on copy.
 */
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PolicyPage({ eyebrow, title, lastUpdated, children, testid }) {
  return (
    <section className="bg-white" data-testid={testid}>
      <div className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] font-semibold text-zinc-500 hover:text-zinc-900 mb-12"
          data-testid="policy-back-link"
        >
          <ArrowLeft size={14} strokeWidth={2} />
          Back to shop
        </Link>

        <div className="text-[10px] uppercase tracking-[0.3em] font-semibold text-zinc-500 mb-4">
          {eyebrow}
        </div>
        <h1
          className="text-5xl md:text-6xl font-black tracking-tighter leading-[0.95] mb-4"
          style={{ fontFamily: "Outfit" }}
          data-testid="policy-title"
        >
          {title}
        </h1>
        {lastUpdated && (
          <div className="text-[11px] uppercase tracking-[0.25em] text-zinc-400 mb-12">
            Last updated · {lastUpdated}
          </div>
        )}

        <article className="policy-prose text-zinc-700 leading-relaxed space-y-6 max-w-none">
          {children}
        </article>
      </div>
    </section>
  );
}
